module.exports = "<div class=\"loginColumns animated fadeInDown\">\n    <div ui-view></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/layouts/plain.html
// module id = 1106
// module chunks = 0